/* Copyright (C) 2016 NooBaa */

import { DUMP_APP_LOG } from 'action-types';

export function dumpAppLog() {
    return { type: DUMP_APP_LOG };
}
